import React from 'react';
import { KatRow, KatColumn } from '@amzn/katal-react';

interface FilterHeaderProps {
    lastRefreshed: string;
    error?: string | null;
}

const FilterHeader: React.FC<FilterHeaderProps> = ({ lastRefreshed, error }) => (
    <KatRow noGutters>
        <KatColumn xs={12}>
            <div className="filters-header">
                <div className="last-refreshed">
                    Last Refreshed {lastRefreshed}
                    {error && <span className="error-info"> | Error: {error}</span>}
                </div>
            </div>
        </KatColumn>
    </KatRow>
);

export default FilterHeader;
